// Anonymous product analytics → POST /events (same allow-listed pipeline as the
// apps; the admin dashboard reads it). Batched, best-effort, never blocks the UI.

import { API_BASE } from "./api";

const INSTALL_KEY = "pashmak.installId";
const INSTALL_DAY_KEY = "pashmak.installDay";

function installId(): string {
  try {
    let id = localStorage.getItem(INSTALL_KEY);
    if (!id) {
      id = `web-${crypto.randomUUID()}`;
      localStorage.setItem(INSTALL_KEY, id);
      localStorage.setItem(INSTALL_DAY_KEY, new Date().toISOString().slice(0, 10));
      queue.push({ name: "first_open", ts: Date.now(), props: {} });
    }
    return id;
  } catch {
    return "web-ephemeral-0000";
  }
}

const queue: Record<string, unknown>[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;

export function track(event: string, props: Record<string, string | number | boolean> = {}) {
  queue.push({ name: event, ts: Date.now(), props });
  if (!timer) timer = setTimeout(send, 3000);
}

function send() {
  timer = null;
  if (!queue.length) return;
  const events = queue.splice(0, 50);
  let installDay = "";
  try {
    installDay = localStorage.getItem(INSTALL_DAY_KEY) || "";
  } catch {
    /* ignore */
  }
  const body = JSON.stringify({
    installId: installId(),
    appVersion: "web-1.1",
    build: (import.meta.env.VITE_BUILD as string) || "dev",
    osVersion: navigator.platform?.slice(0, 20) || "",
    locale: navigator.language,
    region: (navigator.language.split("-")[1] || "").toUpperCase(),
    installDay,
    platform: "web",
    events,
  });
  // keepalive: survives the tab closing.
  void fetch(`${API_BASE}/events`, { method: "POST", headers: { "content-type": "application/json" }, body, keepalive: true }).catch(() => {});
}

if (typeof window !== "undefined") {
  installId();
  document.addEventListener("visibilitychange", () => document.visibilityState === "hidden" && send());
}
